import React from 'react'

const RenderAccountList = ({data,account,newAccounts}) => {
  let _newAccounts = newAccounts !== undefined ? newAccounts : []
  var mergeAccounts = [...data.accountsList, ..._newAccounts]
  var account = mergeAccounts.filter( id => id.id === account)[0]
  if(account !== '' && account !== null && account !== undefined){
    return (
      <div>
       <span>{account.accountType !== undefined ? account.accountType.name + ',' : ''}</span>
       <span>{account.accountNumber !== undefined && account.accountNumber !== ''? account.accountNumber + ',' : ''}</span>
       <span>{account.branchCode !== undefined && account.branchCode !== '' ? account.branchCode : ''}</span>
       <span>{account.country !== undefined ? account.country.name + ',' : ''}</span>
       <span>{account.currency !== undefined ? account.currency.name : ''}</span>
       <br/>
       <span>{account.accountHolder !== undefined ? account.accountHolder.name : ''}</span>
       <br/>
       <span>{account.hsbcBankName !== undefined ? account.hsbcBankName.name + ',' : ''}</span>
       <span>{account.bankName !== undefined ? account.bankName + ',': ''}</span>
       <span>{account.accountTitle !== undefined ? account.accountTitle : ''}</span>
       <span>{account.tempRefrenceId !== undefined && account.tempRefrenceId !== '' ? `(${account.tempRefrenceId})` : ''}</span>
      </div>
    )
  }else {
    return ''
  }
}

const AdvanceAllocationSetting = ({pageJson, data, translations,newAccounts}) => (
  <div className="pooling-structure-container__advance-allocation">
  <div className="hrLine"></div>
    <dl className="detail-container__horizontal-row clearfix">
      <dt>{`${translations(pageJson.aSTitle)}`}</dt>
        <dd className="hrLine"></dd>
      {
        data.allocationSettings !== undefined && data.allocationSettings.allocationMethod !== undefined
        ? [
            <dt>{translations(pageJson.aSMethod)}</dt>,
            <dd>{data.allocationSettings.allocationMethod.replace(/([A-Z])/g, ' $1').trim()}</dd>
          ]
        : null
      }
      {
        data.allocationSettings.nominatedPoolingAccount !== undefined && data.allocationSettings.nominatedPoolingAccount !== ''
        ? [
            <dt>{translations(pageJson.aSNominatedAccount)}</dt>,
            <dd>
              <RenderAccountList
                data={data}
                account={data.allocationSettings.nominatedPoolingAccount}
                newAccounts={newAccounts}
              />
            </dd>
          ]
        : null
      }
      {
        data.allocationSettings !== undefined && data.allocationSettings.defaultSettlementAccount !== undefined
        ? [
            <dt>{translations(pageJson.aSDefaultAccount)}</dt>,
            <dd>{data.allocationSettings.defaultSettlementAccount.replace(/([A-Z])/g, ' $1').trim()}</dd>
          ]
        : null
      }
      {
        data.allocationSettings.other !== undefined && data.allocationSettings.other !== ''
        ? [
            <dt>&nbsp;</dt>,
            <dd>
              <RenderAccountList
                data={data}
                account={data.allocationSettings.other}
                newAccounts={newAccounts}
              />
            </dd>
          ]
        : null
      }

      <dt>{translations(pageJson.aSNetBalance)}</dt>
      <dd>&nbsp;</dd>

      <dt className="sub-heading">{translations(pageJson.credit)}</dt>
      <dd>&nbsp;</dd>
      {
        data.allocationSettings.interestCredit !== undefined && data.allocationSettings.interestCredit.baseRate !== undefined
        ? [
            <dt>{translations(pageJson.aSBaseRate)}</dt>,
            <dd>{data.allocationSettings.interestCredit.baseRate}</dd>
          ]
        : null
      }
      {
        data.allocationSettings.interestCredit !== undefined && data.allocationSettings.interestCredit.baseRateCode !== undefined
        ? [
            <dt>{translations(pageJson.aSCode)}</dt>,
            <dd>{data.allocationSettings.interestCredit.baseRateCode}</dd>
          ]
        : null
      }
      {
        data.allocationSettings.interestCredit !== undefined && data.allocationSettings.interestCredit.spread !== undefined
        ? [
            <dt>{translations(pageJson.aSSpread)}</dt>,
            <dd>{data.allocationSettings.interestCredit.spread}</dd>

          ]
        : null
      }

      <dt>&nbsp;</dt>
      <dd>
        {
          data.allocationSettings.interestCredit !== undefined && data.allocationSettings.interestCredit.rate !== undefined
          ? data.allocationSettings.interestCredit.rate === "true"
            ? translations(pageJson.aSMargin)
            : translations(pageJson.aSFixedValue)
          : ''
         }
      </dd>
      {
        data.allocationSettings.interestCredit !== undefined && data.allocationSettings.interestCredit.minimumInterest !== undefined
        ? [
            <dt>{translations(pageJson.minInterest)}</dt>,
            <dd>{data.allocationSettings.interestCredit.minimumInterest}</dd>
          ]
        : null
      }
      {
        data.allocationSettings.interestCredit !== undefined && data.allocationSettings.interestCredit.maximumInterest !== undefined
        ? [
            <dt>{translations(pageJson.maxInterest)}</dt>,
            <dd>{data.allocationSettings.interestCredit.maximumInterest}</dd>
          ]
        : null
      }

      <dt className="sub-heading">{translations(pageJson.debit)}</dt>
      <dd>&nbsp;</dd>

      {
        data.allocationSettings.interestDebit !== undefined && data.allocationSettings.interestDebit.baseRate !== undefined
        ? [
            <dt>{translations(pageJson.aSBaseRate)}</dt>,
            <dd>{data.allocationSettings.interestDebit.baseRate}</dd>
          ]
        : null
      }
      {
        data.allocationSettings.interestDebit !== undefined && data.allocationSettings.interestDebit.baseRateCode !== undefined
        ? [
            <dt>{translations(pageJson.aSCode)}</dt>,
            <dd>{data.allocationSettings.interestDebit.baseRateCode}</dd>
          ]
        : null
      }
      {
        data.allocationSettings.interestDebit !== undefined && data.allocationSettings.interestDebit.spread !== undefined
        ? [
            <dt>{translations(pageJson.aSSpread)}</dt>,
            <dd>{data.allocationSettings.interestDebit.spread}</dd>
          ]
        : null
      }

      <dt>&nbsp;</dt>
      <dd>
        {
          data.allocationSettings.interestDebit !== undefined && data.allocationSettings.interestDebit.rate !== undefined
          ? data.allocationSettings.interestDebit.rate === "true"
            ? translations(pageJson.aSMargin)
            : translations(pageJson.aSFixedValue)
          : ''
        }
      </dd>
      {
        data.allocationSettings.interestDebit !==  undefined && data.allocationSettings.interestDebit.minimumInterest !== undefined
        ? [
            <dt>{translations(pageJson.minInterest)}</dt>,
            <dd>{data.allocationSettings.interestDebit.minimumInterest}</dd>
          ]
        : null
      }
      {
        data.allocationSettings.interestDebit !== undefined && data.allocationSettings.interestDebit.maximumInterest !== undefined
        ? [
            <dt>{translations(pageJson.maxInterest)}</dt>,
            <dd>{data.allocationSettings.interestDebit.maximumInterest}</dd>
          ]
        : null
      }
      {
        data.allocationSettings !== undefined && data.allocationSettings.odLimit !== undefined
        ? [
            <dt>{translations(pageJson.setOdLimit)}</dt>,
            <dd>{data.allocationSettings.odLimit}</dd>
          ]
        : null
      }

      <dt>{translations(pageJson.interestType)}</dt>
      <dd>
        {
          data.allocationSettings.unauthorisedOD !== undefined && data.allocationSettings.unauthorisedOD.interestRateType  !== undefined
          ? data.allocationSettings.unauthorisedOD.interestRateType === "true"
            ? translations(pageJson.floating)
            : translations(pageJson.fixed)
          :''
        }
      </dd>

      <dt className="sub-heading">{translations(pageJson.unauthorisedOd)}</dt>
      <dd>&nbsp;</dd>
      {
        data.allocationSettings.unauthorisedOD !== undefined && data.allocationSettings.unauthorisedOD.baseRate !== undefined
        ? [
            <dt>{translations(pageJson.aSBaseRate)}</dt>,
            <dd>{data.allocationSettings.unauthorisedOD.baseRate}</dd>
          ]
        : null
      }
      {
        data.allocationSettings.unauthorisedOD !== undefined && data.allocationSettings.unauthorisedOD.baseRateCode !== undefined
        ? [
            <dt>{translations(pageJson.aSCode)}</dt>,
            <dd>{data.allocationSettings.unauthorisedOD.baseRateCode}</dd>

          ]
        : null
      }
      {
        data.allocationSettings.unauthorisedOD !== undefined && data.allocationSettings.unauthorisedOD.spread !== undefined
        ? [
            <dt>{translations(pageJson.aSSpread)}</dt>,
            <dd>{data.allocationSettings.unauthorisedOD.spread}</dd>
          ]
        : null
      }

      <dt>&nbsp;</dt>
      <dd>
        {
          data.allocationSettings.unauthorisedOD !== undefined && data.allocationSettings.unauthorisedOD.rate !== undefined
          ? data.allocationSettings.unauthorisedOD.rate === "true"
            ? translations(pageJson.aSMargin)
            : translations(pageJson.aSFixedValue)
          :''
        }
      </dd>
      {
        data.allocationSettings.unauthorisedOD !== undefined && data.allocationSettings.unauthorisedOD.minimumInterest !== undefined
        ? [
            <dt>{translations(pageJson.minInterest)}</dt>,
            <dd>{data.allocationSettings.unauthorisedOD.minimumInterest}</dd>
          ]
        : null
      }
      {
        data.allocationSettings.unauthorisedOD !== undefined && data.allocationSettings.unauthorisedOD.maximumInterest !== undefined
        ? [
            <dt>{translations(pageJson.maxInterest)}</dt>,
            <dd>{data.allocationSettings.unauthorisedOD.maximumInterest}</dd>
          ]
        : null
      }
      </dl>

      <div className="detail-container__horizontal-row clearfix border">
      {
        data.allocationSettings.accountSettings.map((item) =>
        <dl>
          <dt>
            <RenderAccountList
              data={data}
              account={item.id}
              newAccounts={newAccounts}
            />
          </dt>
          <dd>&nbsp;</dd>

          <dt className="sub-heading">{translations(pageJson.aSCreditBalance)}</dt>
          <dd>&nbsp;</dd>

          {
            item.coveredCreditBalance !== undefined && item.coveredCreditBalance.baseRate !== undefined
            ? [
                <dt>{translations(pageJson.aSBaseRate)}</dt>,
                <dd>{item.coveredCreditBalance.baseRate}</dd>
              ]
            : null
          }
          {
            item.coveredCreditBalance !== undefined && item.coveredCreditBalance.baseRateCode !== undefined
            ? [
                <dt>{translations(pageJson.aSCode)}</dt>,
                <dd>{item.coveredCreditBalance.baseRateCode}</dd>
              ]
            : null
          }
          {
            item.coveredCreditBalance.spread !== undefined && item.coveredCreditBalance.spread !== undefined
            ? [
                <dt>{translations(pageJson.aSSpread)}</dt>,
                <dd>{item.coveredCreditBalance.spread}</dd>
              ]
            : null
          }

          <dt>&nbsp;</dt>
          <dd>
            {
              item.coveredCreditBalance !== undefined && 'marginBaseRate' in item.coveredCreditBalance && item.coveredCreditBalance.marginBaseRate === true
              ? translations(pageJson.aSMargin)
              : ''
            }
            {
              item.coveredCreditBalance !== undefined && 'fixedValue' in item.coveredCreditBalance && item.coveredCreditBalance.fixedValue === false
              ? translations(pageJson.aSFixedValue)
              : ''
            }
          </dd>
          {
            item.coveredCreditBalance !== undefined && item.coveredCreditBalance.minimumInterest !== undefined
            ? [
                <dt>{translations(pageJson.minInterest)}</dt>,
                <dd>{item.coveredCreditBalance.minimumInterest}</dd>
              ]
            : null
          }
          {
            item.coveredCreditBalance !== undefined && item.coveredCreditBalance.maximumInterest !== undefined
            ? [
                <dt>{translations(pageJson.maxInterest)}</dt>,
                <dd>{item.coveredCreditBalance.maximumInterest}</dd>
              ]
            : null
          }

          <dt className="sub-heading">{translations(pageJson.aSDebitBalance)}</dt>
          <dd>&nbsp;</dd>

          {
            item.coveredDebitBalance !== undefined && item.coveredDebitBalance.baseRate !== undefined
            ? [
                <dt>{translations(pageJson.aSBaseRate)}</dt>,
                <dd>{item.coveredDebitBalance.baseRate}</dd>
              ]
            : null
          }
          {
            item.coveredDebitBalance !== undefined && item.coveredDebitBalance.baseRateCode !== undefined
            ? [
                <dt>{translations(pageJson.aSCode)}</dt>,
                <dd>{item.coveredDebitBalance.baseRateCode}</dd>
              ]
            : null
          }
          {
            item.coveredDebitBalance.spread !== undefined && item.coveredDebitBalance.spread !== undefined
            ? [
                <dt>{translations(pageJson.aSSpread)}</dt>,
                <dd>{item.coveredDebitBalance.spread}</dd>
              ]
            : null
          }

          <dt>&nbsp;</dt>
          <dd>
            {
              item.coveredDebitBalance !== undefined && 'marginBaseRate' in item.coveredDebitBalance && item.coveredDebitBalance.marginBaseRate === true
              ? translations(pageJson.aSMargin)
              : ''
            }
            {
              item.coveredDebitBalance !== undefined && 'fixedValue' in item.coveredDebitBalance && item.coveredDebitBalance.fixedValue === false
              ? translations(pageJson.aSFixedValue)
              : ''
            }
          </dd>
          {
            item.coveredDebitBalance !==  undefined && item.coveredDebitBalance.minimumInterest !== undefined
            ? [
                <dt>{translations(pageJson.minInterest)}</dt>,
                <dd>{item.coveredDebitBalance.minimumInterest}</dd>
              ]
            : null
          }
          {
            item.coveredDebitBalance !== undefined && item.coveredDebitBalance.maximumInterest !== undefined
            ? [
                <dt>{translations(pageJson.maxInterest)}</dt>,
                <dd>{item.coveredDebitBalance.maximumInterest}</dd>
              ]
            : null
          }
          {
            item.odLimit !== undefined
            ? [
                <dt>{translations(pageJson.setOdLimit)}</dt>,
                <dd>{item.odLimit}</dd>
              ]
            : null
          }

          <dt>{translations(pageJson.interestType)}</dt>
          <dd>
            {
              item.unauthorizedInterestType  !== undefined
              ? item.unauthorizedInterestType === "true"
                ? translations(pageJson.floating)
                : translations(pageJson.fixed)
              : ''
            }
          </dd>

          <dt className="sub-heading">{translations(pageJson.unauthorisedOd)}</dt>
          <dd>&nbsp;</dd>

          {
            item.unAuthorisedOD !== undefined && item.unAuthorisedOD.baseRate !== undefined
            ? [
                <dt>{translations(pageJson.aSBaseRate)}</dt>,
                <dd>{item.unAuthorisedOD.baseRate}</dd>
              ]
            : null
          }
          {
            item.unAuthorisedOD !== undefined && item.unAuthorisedOD.baseRateCode !== undefined
            ? [
                <dt>{translations(pageJson.aSCode)}</dt>,
                <dd>{item.unAuthorisedOD.baseRateCode}</dd>
              ]
            : null
          }
          {
            item.unAuthorisedOD !== undefined && item.unAuthorisedOD.spread !== undefined
            ? [
                <dt>{translations(pageJson.aSSpread)}</dt>,
                <dd>{item.unAuthorisedOD.spread}</dd>
              ]
            : null
          }

          <dt>&nbsp;</dt>
          <dd>
            {
              item.unAuthorisedOD !== undefined && 'marginBaseRate' in item.unAuthorisedOD && item.unAuthorisedOD.marginBaseRate === true
              ? translations(pageJson.aSMargin)
              : ''
            }
            {
              item.unAuthorisedOD !== undefined && 'fixedValue' in item.unAuthorisedOD && item.unAuthorisedOD.fixedValue === false
              ? translations(pageJson.aSFixedValue)
              : ''
            }
          </dd>
          {
            item.unAuthorisedOD !== undefined && item.unAuthorisedOD.minimumInterest !== undefined
            ? [
                <dt>{translations(pageJson.minInterest)}</dt>,
                <dd>{item.unAuthorisedOD.minimumInterest}</dd>
              ]
            : null
          }
          {
            item.unAuthorisedOD !== undefined && item.unAuthorisedOD.maximumInterest !== undefined
            ? [
                <dt>{translations(pageJson.maxInterest)}</dt>,
                <dd>{item.unAuthorisedOD.maximumInterest}</dd>
              ]
            : null
          }
        </dl>
      )
    }
    </div>
</div>)

export default AdvanceAllocationSetting;



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/NPPreview/PoolingStructure/advanceAllocationSettings.js